<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Reactions</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('reactions.create')">
        <span>Add</span>
        <span class="hidden md:inline">Reaction</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Enabled</th>
          <th class="px-6 pt-6 pb-4">Name</th>
          <th class="px-6 pt-6 pb-4">#</th>
          <th class="px-6 pt-6 pb-4">Triggers</th>
          <th class="px-6 pt-6 pb-4">Replies</th>
<!--
          <th class="px-6 pt-6 pb-4">Randomness</th>
          <th class="px-6 pt-6 pb-4">Mention User</th>
          <th class="px-6 pt-6 pb-4">Stream Title Hashtags</th>
          <th class="px-6 pt-6 pb-4">Stream Tags</th>
          <th class="px-6 pt-6 pb-4">Stream Category</th>
          -->
        </tr>
        <tr v-for="reaction in reactions.data" :key="reaction.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.is_enabled == true ? "🟢" : "🔴" }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('reactions.edit', reaction.id)">
              {{ reaction.name }}
              <icon v-if="reaction.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ getTriggerCount(reaction.triggers) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ truncateString(formatTriggers(reaction.triggers), 80) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              <index-preview :preview_message="truncateString(reaction.reply, 80)" />
            </inertia-link>
          </td>
          <!--
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.random }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.mention_user == true ? "Yes" : "No" }}
            </inertia-link>
          </td>

          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.stream_title_hashtag }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.stream_tags }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              {{ reaction.stream_game }}
            </inertia-link>
          </td>
          -->
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('reactions.edit', reaction.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="reactions.data.length === 0">
          <td class="border-t px-6 py-4" colspan="9">No reactions found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="reactions.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import IndexPreview from '@/Shared/IndexPreview.vue'

export default {
  metaInfo: { title: 'Reactions' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    IndexPreview,
  },
  layout: Layout,
  props: {
    filters: Object,
    reactions: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('reactions'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    formatTriggers(triggers) {
      if (!triggers) return '-'

      const clean = (s) => {
        if (s === null || s === undefined) return ''
        let out = String(s)
        // decode unicode escapes \uXXXX
        out = out.replace(/\\u([0-9a-fA-F]{4})/g, (_, g1) => String.fromCharCode(parseInt(g1, 16)))
        // unescape escaped slashes
        out = out.replace(/\\\//g, '/')
        // remove backslash escapes (e.g. \" -> ")
        out = out.replace(/\\(.)/g, '$1')
        // replace newlines/tabs with space
        out = out.replace(/[\r\n\t]+/g, ' ')
        return out.trim()
      }

      try {
        let parts = []
        if (Array.isArray(triggers)) {
          parts = triggers
        } else if (typeof triggers === 'string') {
          const parsed = JSON.parse(triggers)
          if (Array.isArray(parsed)) {
            parts = parsed
          } else {
            parts = String(triggers).split(/[\n,;]+/)
          }
        } else {
          parts = [String(triggers)]
        }

        const cleaned = parts.map(clean).filter(p => p && p.length)
        return cleaned.length ? cleaned.join(', ') : '-'
      } catch (e) {
        const parts = String(triggers).split(/[\n,;]+/).map(p => clean(p)).filter(Boolean)
        return parts.length ? parts.join(', ') : '-'
      }
    },

    getTriggerCount(triggers) {
      if (!triggers) return 0
      if (Array.isArray(triggers)) return triggers.length
      try {
        const parsed = typeof triggers === 'string' ? JSON.parse(triggers) : triggers
        if (Array.isArray(parsed)) return parsed.length
      } catch (e) {
        // fall back to splitting
      }
      const parts = String(triggers).split(/[\n,;]+/).map(s => s.trim()).filter(Boolean)
      return parts.length
    },

    truncateString(str, len = 80) {
      if (!str && str !== 0) return '-'
      let s = String(str)
      // remove common escapes and trims
      s = s.replace(/\\u([0-9a-fA-F]{4})/g, (_, g1) => String.fromCharCode(parseInt(g1, 16)))
      s = s.replace(/\\\//g, '/')
      s = s.replace(/\\(.)/g, '$1')
      s = s.replace(/[\r\n\t]+/g, ' ')
      s = s.trim()
      if (s.length <= len) return s
      return s.slice(0, len).trim() + ' (...)'
    },
  },
}
</script>
